import { Modal, Select } from 'antd';

import type { LeadsRegistryAssigneeOption } from '../../../../model/types';
import type { FC } from 'react';

import './LeadsRegistryAssignModal.scss';

interface LeadsRegistryAssignModalProps {
  open: boolean;
  options: LeadsRegistryAssigneeOption[];
  selectedUserId: number | null;
  isLoading: boolean;
  onChange(userId: number): void;
  onCancel(): void;
  onConfirm(): void;
}

const UNASSIGNED_OPTION: LeadsRegistryAssigneeOption = {
  value: 0,
  label: 'Без ответственного',
};

export const LeadsRegistryAssignModal: FC<LeadsRegistryAssignModalProps> = ({
  open,
  options,
  selectedUserId,
  isLoading,
  onChange,
  onCancel,
  onConfirm,
}) => {
  const selectOptions = [UNASSIGNED_OPTION, ...options];

  return (
    <Modal
      className="LeadsRegistryAssignModal"
      title="Назначить ответственного"
      open={open}
      okText="Сохранить"
      cancelText="Отменить"
      onOk={onConfirm}
      onCancel={onCancel}
      okButtonProps={{ loading: isLoading, disabled: selectedUserId === null }}
      cancelButtonProps={{ disabled: isLoading }}
    >
      <Select<number>
        className="LeadsRegistryAssignModal__select"
        showSearch
        placeholder="Выберите сотрудника"
        optionFilterProp="label"
        options={selectOptions}
        value={selectedUserId ?? undefined}
        onChange={onChange}
      />
    </Modal>
  );
};
